import { RFMOfferUI } from 'domains/workspaceDomain';
import dayjs from 'dayjs';

/** offers run in cycles of three: a job coming back to the board opens the next cycle */
export const OFFERS_PER_CYCLE = 3;

/**
 * A new round runs until the last second of the next business day: Fri and Sat roll to Monday.
 */
export const nextBusinessDayEnd = () => {
  const today = dayjs();
  const daysToAdd = today.day() < 5 ? 1 : 8 - today.day();
  return today.add(daysToAdd, 'day').endOf('day').toISOString();
};

export const highestRoundOf = (offers?: RFMOfferUI[]) =>
  (offers || []).reduce((highest, offer) => Math.max(highest, offer.round), 0);

/**
 * Whether a further round can be offered: a saved round to build on, the cycle not used up, no
 * draft already open, and the RFM not cancelled. Shared so the button above the table and the one
 * in the row cannot disagree about it.
 */
export const nextOfferAvailable = (
  offers?: RFMOfferUI[],
  nextOffer?: RFMOfferUI
) => {
  if (!offers?.length || nextOffer) {
    return false;
  }
  if (offers.some((offer) => offer.cancelled)) {
    return false;
  }
  const highestRound = highestRoundOf(offers);
  const latest = offers.find((offer) => offer.round === highestRound);
  if (!latest || latest.id === undefined) {
    return false;
  }
  return highestRound % OFFERS_PER_CYCLE !== 0;
};
